var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dbi-messages',{attrs:{"messages":_vm.messages},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h2',[_vm._v("HIM-Meldungen")])]},proxy:true},{key:"default",fn:function(ref){
var msg = ref.msg;
return [_c('svg-sprite',{attrs:{"icon":"warning"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(msg.text))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }